import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  root: {
    display: "block",
    width: "100%",
    backgroundColor: "transparent",
  },
  loader: {
    marginLeft: 15,
  },
  container: {
    minHeight: "150px",
    width: "100%",
    border: "none",
    overflowX: "initial",
  },
  tableSort: {
    color: "#2A3333 !important",
    "& svg": {
      color: "#2A3333 !important",
    },
  },
  cellHead: {
    position: "sticky",
    padding: "16px",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "24px",
    color: "#2A3333",
    whiteSpace: "nowrap",
    height: 56,
    fontFamily: "Cairo",
    background: "#F5F8FE",
    border: "none",
    textAlign: "left",
    "&.makeStyles-cellHead-33": {
      backgroundColor: "transparent",
      color: "#BDBDBD",
    },
  },
  cellHeadWithoutWidth: {
    padding: "16px",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "24px",
    textAlign: "left",
    color: "#2A3333",
    height: 56,
    fontFamily: "Cairo",
    background: "#F5F8FE",
    border: "none",
    whiteSpace: "nowrap",
    "&.makeStyles-cellHead-33": {
      backgroundColor: "transparent",
      color: "#BDBDBD",
    },
  },
  tableBody: {
    backgroundColor: "transparent",
    "& .MuiTableRow-root:nth-of-type(even)": {
      backgroundColor: "#F5F8FE",
    },
    border: "none",
    "& .MuiTableCell-root": {
      border: "none",
      backgroundColor: "transparent",
    },
  },
  table: {
    background: "#fff",
    width: "100%",
    borderCollapse: "collapse",
    "& .MuiTableCell-root": {
      borderBottom: "none",
    },
  },
  headerCheckbox: {
    padding: 0,
    width: 18,
    height: 18,
    marginRight: 14,
  },
  customCheckbox: {
    padding: 0,
    width: 18,
    height: 18,
  },
  iconButton: {
    padding: "0px",
    marginLeft: "5px",
    marginRight: "5px",
  },
  overrideIconButton: {
    position: "relative",
    right: -20,
  },
  downloadBtn: {
    cursor: "pointer",
  },
  link: {
    fontSize: 14,
    fontWeight: 700,
    color: "#3d63e6",
    fontFamily: "Cairo",
  },
});
